<datex-grid #$gridComponent *ngIf="initialized " [selection]="true" (selectionChange)="$selectionChanged($event)" [headers]="headers" [rows]="rows" [(pageSize)]="pageSize" [(pageSkip)]="pageSkip" [totalCount]="totalCount" [loadingStatus]="loadingStatus" (pageChange)="$dataLoad()" [containerStyles]="containerStyles"



>
    <ng-container topToolbar>
      <app-toolbar [toolbar]="topToolbar">
          <ng-template 
            toolbarToolDef="resolve_tasks" let-tool>
            <ng-container  *ngIf="tool.hasButtonsToShow">
            <button mat-button
                    data-cy="button"
                    class="datex-button"
                    [disabled]="tool.control.readOnly || tool.control.disabled"
                    [ngStyle]="tool.control.styles.style"
                    [ngClass]="tool.control.styles.classes"
                    [matTooltip]="tool.control.tooltip"
                    matTooltipClass="datex-control-tooltip"
                    (click)="on_resolve_tasks_clicked($event)"
                    >
              <div class="button-label">
                <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                  <div class="button-icon">
                    <i data-cy="button-icon" class="datex-default-spinner"></i>
                  </div>
                </ng-container>
                <ng-template #showIcon>
                  <div class="button-icon">
                    <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                  </div>
                </ng-template>
                <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
              </div>
            
            </button>
            </ng-container>
          </ng-template>
          <ng-template 
            toolbarToolDef="recount_tasks" let-tool>
            <ng-container  *ngIf="tool.hasButtonsToShow">
            <button mat-button
                    data-cy="button"
                    class="datex-button"
                    [disabled]="tool.control.readOnly || tool.control.disabled"
                    [ngStyle]="tool.control.styles.style"
                    [ngClass]="tool.control.styles.classes"
                    [matTooltip]="tool.control.tooltip"
                    matTooltipClass="datex-control-tooltip"
                    (click)="on_recount_tasks_clicked($event)"
                    >
              <div class="button-label">
                <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                  <div class="button-icon">
                    <i data-cy="button-icon" class="datex-default-spinner"></i>
                  </div>
                </ng-container>
                <ng-template #showIcon>
                  <div class="button-icon">
                    <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                  </div>
                </ng-template>
                <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
              </div>
            
            </button>
            </ng-container>
          </ng-template>
          <ng-template 
            toolbarToolDef="separator1" let-tool>
            <ng-container  *ngIf="tool.hasButtonsToShow">
            <div class="tool-separator"></div>
            </ng-container>
          </ng-template>
          <ng-template 
            toolbarToolDef="cancel_tasks" let-tool>
            <ng-container  *ngIf="tool.hasButtonsToShow">
            <button mat-button
                    data-cy="button"
                    class="datex-button"
                    [disabled]="tool.control.readOnly || tool.control.disabled"
                    [ngStyle]="tool.control.styles.style"
                    [ngClass]="tool.control.styles.classes"
                    [matTooltip]="tool.control.tooltip"
                    matTooltipClass="datex-control-tooltip"
                    (click)="on_cancel_tasks_clicked($event)"
                    >
              <div class="button-label">
                <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                  <div class="button-icon">
                    <i data-cy="button-icon" class="datex-default-spinner"></i>
                  </div>
                </ng-container>
                <ng-template #showIcon>
                  <div class="button-icon">
                    <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                  </div>
                </ng-template>
                <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
              </div>
            
            </button>
            </ng-container>
          </ng-template>
          <ng-template 
            toolbarToolDef="separator2" let-tool>
            <ng-container  *ngIf="tool.hasButtonsToShow">
            <div class="tool-separator"></div>
            </ng-container>
          </ng-template>
          <ng-template 
            toolbarToolDef="override_tasks" let-tool>
            <ng-container  *ngIf="tool.hasButtonsToShow">
            <button mat-button
                    data-cy="button"
                    class="datex-button"
                    [disabled]="tool.control.readOnly || tool.control.disabled"
                    [ngStyle]="tool.control.styles.style"
                    [ngClass]="tool.control.styles.classes"
                    [matTooltip]="tool.control.tooltip"
                    matTooltipClass="datex-control-tooltip"
                    (click)="on_override_tasks_clicked($event)"
                    >
              <div class="button-label">
                <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                  <div class="button-icon">
                    <i data-cy="button-icon" class="datex-default-spinner"></i>
                  </div>
                </ng-container>
                <ng-template #showIcon>
                  <div class="button-icon">
                    <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                  </div>
                </ng-template>
                <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
              </div>
            
            </button>
            </ng-container>
          </ng-template>
      </app-toolbar>
    <div class="query-filter">
      <input
        matInput
        [(ngModel)]="fullTextSearch" 
        (ngModelChange)="reload()" 
        [ngModelOptions]="{updateOn: 'blur'}"
        autocomplete="off"
        class="datex-textbox query-search"
        spellcheck="false"
        placeholder="Filter"
        [matTooltip]="fullTextSearch"
        matTooltipClass="datex-control-tooltip">
    </div>
  </ng-container>

  <ng-container filters>
    <div class="fieldsetsContainer" [formGroup]="formGroup">
      <div class="fieldsetsGroup">
      <div data-cy="field-id-only_discrepancies" *ngIf="!filters.only_discrepancies.hidden && !filters.only_discrepancies.removed" 
            class="field-container standard {{filters.only_discrepancies.invalid ? 'invalid' : ''}} {{filters.only_discrepancies.control.disabled ? 'field-container-disabled' : ''}}"
            [ngStyle]="filters.only_discrepancies.styles.style"
            [ngClass]="filters.only_discrepancies.styles.classes">
        <div class="label-container"
             [matTooltip]="filters.only_discrepancies.label + (filters.only_discrepancies.required ? ' (required)' : '')"
             matTooltipClass="datex-control-tooltip">
          <label data-cy="field-label" class="datex-label">{{filters.only_discrepancies.label}}<span *ngIf="filters.only_discrepancies.required" class="required-asterisk">*</span>
          </label>
        </div>
        <mat-checkbox data-cy="checkBox" formControlName="only_discrepancies"
                      class="datex-checkbox"
                      color="primary"
                      [ngStyle]="filters.only_discrepancies.control.styles.style"
                      [ngClass]="filters.only_discrepancies.control.styles.classes"
                      [matTooltip]="filters.only_discrepancies.control.tooltip"
                      matTooltipClass="datex-control-tooltip">{{filters.only_discrepancies.control.label}}</mat-checkbox>
        <ng-container *ngIf="filters.only_discrepancies.invalid">
          <ng-container *ngFor="let error of filters.only_discrepancies.errors">
            <span class="invalid-message">
              {{error}}
            </span>
          </ng-container>
        </ng-container>
      </div>      <div data-cy="field-id-statuses" *ngIf="!filters.statuses.hidden && !filters.statuses.removed" 
            class="field-container full {{filters.statuses.invalid ? 'invalid' : ''}} {{filters.statuses.control.disabled ? 'field-container-disabled' : ''}}"
            [ngStyle]="filters.statuses.styles.style"
            [ngClass]="filters.statuses.styles.classes">
        <div class="label-container"
             [matTooltip]="filters.statuses.label + (filters.statuses.required ? ' (required)' : '')"
             matTooltipClass="datex-control-tooltip">
          <label data-cy="field-label" class="datex-label">{{filters.statuses.label}}<span *ngIf="filters.statuses.required" class="required-asterisk">*</span>
          </label>
        </div>
        <InventoryCounts-count_task_statuses_dd_multi 
            data-cy="selector-multi"
            [type]="filters.statuses.control.type"
            formControlName="statuses"
            (displayTextChange)="filters.statuses.control.displayText=$event"
            [placeholder]="filters.statuses.control.placeholder"
            [styles]="filters.statuses.control.styles"
            [tooltip]="filters.statuses.control.tooltip"
        >
        </InventoryCounts-count_task_statuses_dd_multi>
        <ng-container *ngIf="filters.statuses.invalid">
          <ng-container *ngFor="let error of filters.statuses.errors">
            <span class="invalid-message">
              {{error}}
            </span>
          </ng-container>
        </ng-container>
      </div>      <div data-cy="field-id-released_from" *ngIf="!filters.released_from.hidden && !filters.released_from.removed" 
            class="field-container standard {{filters.released_from.invalid ? 'invalid' : ''}} {{filters.released_from.control.disabled ? 'field-container-disabled' : ''}}"
            [ngStyle]="filters.released_from.styles.style"
            [ngClass]="filters.released_from.styles.classes">
        <div class="label-container"
             [matTooltip]="filters.released_from.label + (filters.released_from.required ? ' (required)' : '')"
             matTooltipClass="datex-control-tooltip">
          <label data-cy="field-label" class="datex-label">{{filters.released_from.label}}<span *ngIf="filters.released_from.required" class="required-asterisk">*</span>
          </label>
        </div>
        <app-datebox 
            data-cy="dateBox"
            formControlName="released_from"
            [format]="filters.released_from.control.format"
            [mode]="filters.released_from.control.mode"
            [ngStyle]="filters.released_from.control.styles.style"
            [ngClass]="filters.released_from.control.styles.classes"
            [tooltip]="filters.released_from.control.tooltip">
        </app-datebox>
        <ng-container *ngIf="filters.released_from.invalid">
          <ng-container *ngFor="let error of filters.released_from.errors">
            <span class="invalid-message">
              {{error}}
            </span>
          </ng-container>
        </ng-container>
      </div>      <div data-cy="field-id-released_to" *ngIf="!filters.released_to.hidden && !filters.released_to.removed" 
            class="field-container standard {{filters.released_to.invalid ? 'invalid' : ''}} {{filters.released_to.control.disabled ? 'field-container-disabled' : ''}}"
            [ngStyle]="filters.released_to.styles.style"
            [ngClass]="filters.released_to.styles.classes">
        <div class="label-container"
             [matTooltip]="filters.released_to.label + (filters.released_to.required ? ' (required)' : '')"
             matTooltipClass="datex-control-tooltip">
          <label data-cy="field-label" class="datex-label">{{filters.released_to.label}}<span *ngIf="filters.released_to.required" class="required-asterisk">*</span>
          </label>
        </div>
        <app-datebox 
            data-cy="dateBox"
            formControlName="released_to"
            [format]="filters.released_to.control.format"
            [mode]="filters.released_to.control.mode"
            [ngStyle]="filters.released_to.control.styles.style"
            [ngClass]="filters.released_to.control.styles.classes"
            [tooltip]="filters.released_to.control.tooltip">
        </app-datebox>
        <ng-container *ngIf="filters.released_to.invalid">
          <ng-container *ngFor="let error of filters.released_to.errors">
            <span class="invalid-message">
              {{error}}
            </span>
          </ng-container>
        </ng-container>
      </div>      <div data-cy="field-id-reason_codes" *ngIf="!filters.reason_codes.hidden && !filters.reason_codes.removed" 
            class="field-container standard {{filters.reason_codes.invalid ? 'invalid' : ''}} {{filters.reason_codes.control.disabled ? 'field-container-disabled' : ''}}"
            [ngStyle]="filters.reason_codes.styles.style"
            [ngClass]="filters.reason_codes.styles.classes">
        <div class="label-container"
             [matTooltip]="filters.reason_codes.label + (filters.reason_codes.required ? ' (required)' : '')"
             matTooltipClass="datex-control-tooltip">
          <label data-cy="field-label" class="datex-label">{{filters.reason_codes.label}}<span *ngIf="filters.reason_codes.required" class="required-asterisk">*</span>
          </label>
        </div>
        <FootprintManager-reason_codes_dd_multi 
            data-cy="selector-multi"
            [type]="filters.reason_codes.control.type"
            formControlName="reason_codes"
            (displayTextChange)="filters.reason_codes.control.displayText=$event"
            [placeholder]="filters.reason_codes.control.placeholder"
            [styles]="filters.reason_codes.control.styles"
            [tooltip]="filters.reason_codes.control.tooltip"
          [parentEntity]="$fields_reason_codes_selector_inParams_parentEntity"
          [parentId]="$fields_reason_codes_selector_inParams_parentId"
        >
        </FootprintManager-reason_codes_dd_multi>
        <ng-container *ngIf="filters.reason_codes.invalid">
          <ng-container *ngFor="let error of filters.reason_codes.errors">
            <span class="invalid-message">
              {{error}}
            </span>
          </ng-container>
        </ng-container>
      </div>      </div>
    </div>
  </ng-container>

  <ng-container gridColumnDef="status_name">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.status_name.displayControl.styles.style"
          [ngClass]="row.cells.status_name.displayControl.styles.classes"
          [matTooltip]="row.cells.status_name.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.status_name.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="reason_code">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.reason_code.displayControl.styles.style"
          [ngClass]="row.cells.reason_code.displayControl.styles.classes"
          [matTooltip]="row.cells.reason_code.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.reason_code.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="task_id">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.task_id.displayControl.styles.style"
          [ngClass]="row.cells.task_id.displayControl.styles.classes"
          [matTooltip]="row.cells.task_id.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.task_id.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="project_lookupcode">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.project_lookupcode.displayControl.styles.style"
          [ngClass]="row.cells.project_lookupcode.displayControl.styles.classes"
          [matTooltip]="row.cells.project_lookupcode.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.project_lookupcode.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="material_lookupcode">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.material_lookupcode.displayControl.styles.style"
          [ngClass]="row.cells.material_lookupcode.displayControl.styles.classes"
          [matTooltip]="row.cells.material_lookupcode.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.material_lookupcode.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="expected_packaged_amount">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.expected_packaged_amount.displayControl.styles.style"
          [ngClass]="row.cells.expected_packaged_amount.displayControl.styles.classes"
          [matTooltip]="row.cells.expected_packaged_amount.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.expected_packaged_amount.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="last_recorded_amount">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.last_recorded_amount.displayControl.styles.style"
          [ngClass]="row.cells.last_recorded_amount.displayControl.styles.classes"
          [matTooltip]="row.cells.last_recorded_amount.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.last_recorded_amount.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="actual_packaged_amount">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.actual_packaged_amount.displayControl.styles.style"
          [ngClass]="row.cells.actual_packaged_amount.displayControl.styles.classes"
          [matTooltip]="row.cells.actual_packaged_amount.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.actual_packaged_amount.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="vendorlot_lookupcode">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.vendorlot_lookupcode.displayControl.styles.style"
          [ngClass]="row.cells.vendorlot_lookupcode.displayControl.styles.classes"
          [matTooltip]="row.cells.vendorlot_lookupcode.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.vendorlot_lookupcode.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="lot_lookupcode">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.lot_lookupcode.displayControl.styles.style"
          [ngClass]="row.cells.lot_lookupcode.displayControl.styles.classes"
          [matTooltip]="row.cells.lot_lookupcode.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.lot_lookupcode.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="expected_source_licenseplate_lookupcode">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.expected_source_licenseplate_lookupcode.displayControl.styles.style"
          [ngClass]="row.cells.expected_source_licenseplate_lookupcode.displayControl.styles.classes"
          [matTooltip]="row.cells.expected_source_licenseplate_lookupcode.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.expected_source_licenseplate_lookupcode.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="warehouse">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.warehouse.displayControl.styles.style"
          [ngClass]="row.cells.warehouse.displayControl.styles.classes"
          [matTooltip]="row.cells.warehouse.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.warehouse.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="expected_source_location_name">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.expected_source_location_name.displayControl.styles.style"
          [ngClass]="row.cells.expected_source_location_name.displayControl.styles.classes"
          [matTooltip]="row.cells.expected_source_location_name.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.expected_source_location_name.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="storage_category">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.storage_category.displayControl.styles.style"
          [ngClass]="row.cells.storage_category.displayControl.styles.classes"
          [matTooltip]="row.cells.storage_category.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.storage_category.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="release_date">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.release_date.displayControl.styles.style"
          [ngClass]="row.cells.release_date.displayControl.styles.classes"
          [matTooltip]="row.cells.release_date.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.release_date.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="employee">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.employee.displayControl.styles.style"
          [ngClass]="row.cells.employee.displayControl.styles.classes"
          [matTooltip]="row.cells.employee.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.employee.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="notes">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.notes.displayControl.styles.style"
          [ngClass]="row.cells.notes.displayControl.styles.classes"
          [matTooltip]="row.cells.notes.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.notes.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>

<ng-container bottomToolbar>
</ng-container>


</datex-grid>
